/**
 * Configurazione tema Tailwind dinamico
 * Gestisce dark mode e colori dinamici
 */

import { getThemeColors, updateThemeColors } from './colors';

export type ThemeMode = 'light' | 'dark';

/**
 * Applica il tema (light/dark) al documento
 */
export function applyThemeMode(mode: ThemeMode): void {
  const root = document.documentElement;
  if (mode === 'dark') {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }
}

/**
 * Inizializza il tema all'avvio
 */
export function initializeTheme(): void {
  // Applica dark mode se presente nel localStorage
  const savedTheme = localStorage.getItem('THEME_MODE');
  if (savedTheme === 'dark' || savedTheme === 'light') {
    applyThemeMode(savedTheme);
  } else {
    // Default: light mode
    applyThemeMode('light');
  }

  // Applica colori dinamici
  const colors = getThemeColors();
  updateThemeColors(colors);
}

/**
 * Ottiene il tema corrente
 */
export function getCurrentThemeMode(): ThemeMode {
  return document.documentElement.classList.contains('dark') ? 'dark' : 'light';
}
